import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { ICellEditorParams } from 'ag-grid-community'
import Select from 'react-select'

export const MultiSelectOptionsEditor = forwardRef(function MultiSelectOptionsEditor(
  props: ICellEditorParams & { options: { value: string; label: string }[]; isMulti: boolean },
  ref
) {
  const [value, setValue] = useState(props.value)
  const { isMulti, options } = props

  /* Component Editor Lifecycle methods */
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return value
      },

      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false
      },
    }
  })

  return (
    <Select
      isMulti={isMulti}
      options={options}
      styles={{
        control: (baseStyles) => ({ ...baseStyles, minWidth: '240px' }),
      }}
      onChange={(values) => {
        if (isMulti) {
          setValue(values.map((v) => v.value).join(', '))
          return
        }
        setValue(values.value)
      }}
      value={
        typeof value === 'string' ? value?.split(', ').map((v) => ({ value: v, label: v })) : value
      }
    />
  )
})
